import { useSelector } from 'react-redux';

import { HOME } from 'ha/constants/pageNames';
import { usePage } from 'ha/modules/Page/contexts/PageContext';
import { useIntl } from 'ha/i18n';
import {
  getIsAuthenticated,
  getIsAdvertiser,
} from 'ha/modules/AuthLogic/selectors';

import { checkIfCTAVisible } from '../utils';

const useListYourPlaceCTA = () => {
  const { T, urlResolver } = useIntl();
  const { name: pageName, category } = usePage();
  const isVisible = checkIfCTAVisible(pageName, category);

  const isAuthenticated = useSelector(getIsAuthenticated);
  const isAdvertiser = useSelector(getIsAdvertiser);

  let linkLabel = '';

  if (!isAuthenticated) {
    linkLabel = T('For landlords');
  }
  if (isAuthenticated && isAdvertiser) {
    linkLabel = T('Add Listing');
  }
  if (isAuthenticated && !isAdvertiser) {
    linkLabel = T('I am a landlord');
  }

  const isHomePage = HOME === pageName;

  return {
    label: linkLabel,
    href: isAuthenticated
      ? urlResolver.getListYourPlaceUrl()
      : urlResolver.getBecomeAnAdvertiserUrl(),
    rel: isHomePage ? undefined : 'nofollow',
    isVisible,
  };
};

export default useListYourPlaceCTA;
